export default {"src":"/_next/static/media/butterfly3.09f987d9.svg","height":133,"width":118,"blurWidth":0,"blurHeight":0};